import { render, staticRenderFns } from "./AccountBalanceMovementReport.vue?vue&type=template&id=60db4a84&scoped=true&"
import script from "./AccountBalanceMovementReport.vue?vue&type=script&lang=js&"
export * from "./AccountBalanceMovementReport.vue?vue&type=script&lang=js&"
import style0 from "./AccountBalanceMovementReport.vue?vue&type=style&index=0&id=60db4a84&lang=scss&scoped=true&"
import style1 from "./AccountBalanceMovementReport.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60db4a84",
  null
  
)

export default component.exports